module.exports = __webpack_public_path__ + "static/media/searchSupport.78062377.png";